<template>
    <div>
        <div class="row">
            <div class="col-sm-12 pt-0 pb-0 infoBox">
                <div class="tabs-container">
                    <button v-for="(student, index) of students"
                            type="button"
                            class="btn btn-link"
                            @click="changeTab(student.id, index)"
                            :class="{'is-active': index === tabActive}"
                            :key="index"
                    >
                        <span>{{ studentName(student.first_name, student.last_name) }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 pt-12 pb-12 infoBox">
                <div class="diary-navigation">
                    <GradeTooltip />
                    
                    <div class="diary-navigation__select">
                        <span>{{ $t('period') }}</span>
                        <multiselect
                                v-model="currentDate"
                                :options="periodOptions"
                                track-by="name"
                                label="name"
                                :searchable="false"
                                :close-on-select="true"
                                :show-labels="false"
                                :placeholder="$t('choose_period')"
                        ></multiselect>
                    </div>
                    <app-search-form :placeholder="$t('search_course')"></app-search-form>
					
					<app-question-button content_slug="courses_student_diary" class="marginLeft"></app-question-button>
                </div>
            </div>
            <div class="col-sm-12 pt-12 pb-12">
                <vue-custom-scrollbar class="scroll-area calcHeight scroll-area--mb scroll-area--diary">
                    <div v-if="!isFetch" class="diary-table">
                        <div class="diary-table__lc">
                            <!-- <div class="diary-table__heading">{{$t('course')}}</div> -->
                            <ul class="diary-table__courses">
                                <li v-for="item of getCourses" :key="item.id">
                                    {{ item.course_name }}
                                </li>
                            </ul>
                        </div>
                        <vue-custom-scrollbar class="scroll-area scroll-area--mb">
                            <div class="diary-table__rc">
                                <!-- <div class="diary-table__rc-row-head">
                                    <div class="diary-table__heading" v-for="(item, index) of currentMonthRange()" :key="index">
                                        <span>{{ item }}</span>
                                    </div>
                                </div> -->
                                <div class="diary-table__rc-row-rate" v-for="item of getCourses" :key="item.id">
                                    <div
                                        class="diary-table__month"
                                        v-for="(rates, yearMonth) of item.ratesByMonth"
                                        :key="yearMonth"
                                    >
                                        <div class="diary-table__month-name">
                                            {{ setYearMonthStr(yearMonth) }}
                                        </div>

                                        <div class="diary-table__month-rates">
                                            <StudentDiaryTableBody
                                                v-for="(item, index) of rates"
                                                :key="index"
                                                :gradebook="item"
                                                @toggleGradeModal="toggleGradeModal"
                                            />
                                        </div>
                                    </div>
                                    <!-- <div class="diary-table__rate"
                                        v-for="(item, index) of getUniqueGrade(item.rates)"
                                        :key="index"
                                        :class="[{'fiol-day': item.inactive === 1}, {'empty-day': item.rate && item.rate === []}, {'yellow-day': item.rate && item.rate.status === 2}, {'red-day': item.rate && item.rate.status === 3}, {'empty-day': (item.rate && item.rate.status === 4 || item.rate && item.rate.status === 1)}, {'orange-day': item.rate && item.rate.status === 5}]"
                                    >
                                        <span v-if="item.rate.status === 5"><img
                                                :src="env.public_base + '/assets/images/icon-was-ill.svg'" alt=""></span>
                                        <span v-else-if="item.rate.status === 2"><img
                                                :src="env.public_base + '/assets/images/icon-check-work.svg'" alt=""></span>
                                        <span v-else>{{ checkRate(item) || '' }}</span>
                                    </div> -->
                                </div>
                            </div>
                        </vue-custom-scrollbar>
                    </div>

                    <div v-if="getCourses.length === 0 && !isFetch" class="nothing-found text-center">
                        {{ $t('nothing_found') }}
                    </div>
                    
                    <div
                        v-show="isFetch"
                        class="diary-table-loader"
                    >
                        <Loader />
                    </div>
                </vue-custom-scrollbar>
            </div>
        </div>

        <ModalHoverGrade
            v-show="modalGradeOpened"
            :gradebook="modalGradeData"
            :hover-event="gradeHoverEvent"
            @close="closeGradeModal"
        />
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from "../../env";
    import Multiselect from "vue-multiselect";
    import SearchForm from "../../courses/components/SearchForm";
    import moment from "moment";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import Locale from '../../vue-i18n-locales.generated';
    import StudentDiaryTableBody from './StudentDiaryTableBody';
    import ModalHoverGrade from './Modals/ModalHoverGrade';
    import Loader from '../../common_components/Loader';
    import GradeTooltip from '../../common_components/GradeTooltip';
	import QuestionButton from "../../common_components/QuestionButton";

    const $t = function (item) {
        const lang = localStorage.getItem('language') || 'ua';
        return Locale[lang][item];
    };

    const getPeriodOptions = function () {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentSeptember = new Date(`${currentYear}-08-01`);

        const firstSemesterYear =
            today >= currentSeptember ? currentYear : currentYear - 1;
        const secondSemesterYear =
            today >= currentSeptember ? currentYear + 1 : currentYear;

        const options = [
            {
                id: 1,
                date_from: `${firstSemesterYear}-08-01`,
                date_to: `${secondSemesterYear}-07-31`,
                name: $t('academic_year'),
            },
            {
                id: 2,
                date_from: `${firstSemesterYear}-08-01`,
                date_to: `${firstSemesterYear}-12-31`,
                name: $t('first_semester'),
            },
            {
                id: 3,
                date_from: `${secondSemesterYear}-01-01`,
                date_to: `${secondSemesterYear}-07-31`,
                name: $t('second_semester'),
            },
            // {
            //     id: 4,
            //     date_from: `${secondSemesterYear}-08-01`,
            //     date_to: `${secondSemesterYear + 1}-07-31`,
            //     name: $t('next_year'),
            // },
        ];

        return options;
    };

    const periodOptions = getPeriodOptions();

    const semesterYearRatesAlias = 'semesterYearRates';

    export default {
        components: {
            Multiselect,
            appSearchForm: SearchForm,
            vueCustomScrollbar: vueCustomScrollbar,
            StudentDiaryTableBody,
            ModalHoverGrade,
            Loader,
            GradeTooltip,
			appQuestionButton: QuestionButton,
        },
        data: () => ({
            env,
            tabActive: 0,
            currentStudentId: null,
            currentDate: periodOptions[0],
            modalGradeData: null,
            gradeHoverEvent: null,
            modalGradeOpened: false,
            periodOptions,
            isFetch: false,
        }),
        computed: {
            ...mapGetters([
                'search_value',
                'students_payer',
                'timetables_payer'
            ]),
            studentTimetables() {
                if (this.timetables_payer === null) return [];

                const {
                    timetables = [],
                    theme_gradebooks = [],
                    semester_grades = [],
                    year_grades = [],
                    gradebooks = [],
                } = this.timetables_payer;

                const firstSemesterGrades = [];
                const secondSemesterGrades = [];

                semester_grades.forEach((semesterGrade) => {
                    semesterGrade.semester === 1
                    ? firstSemesterGrades.push(semesterGrade)
                    : secondSemesterGrades.push(semesterGrade);
                });

                const newObj = [];
                const courses = [];

                const courseMap = new Map(); // для семестровых
                const themeTimetableMap = new Map();

                const today = new Date();
                const todayTime = today.getTime();

                timetables.forEach((timetable) => {
                    const { course_name, date, gbooks, course_id, theme_id, id } = timetable;

                    const course = { course_id, course_name, rates: [] };
                    const lessonDate = new Date(date);
                    const isBigerToday = lessonDate.getTime() > todayTime;
                    const getBook = (book) => book.timetable === id;
                    const rate = gradebooks.find(getBook);

                    course.rates.push({
                    date,
                    isBigerToday,
                    timetable,
                    rate,
                    isSimple: true,
                    });

                    newObj.push(course);

                    courseMap.set(course_id, timetable);

                    const existTheme = themeTimetableMap.get(theme_id);

                    if (existTheme === undefined) {
                    themeTimetableMap.set(theme_id, timetable);
                    } else {
                    const existThemeDate = new Date(existTheme.date);
                    const currentThemeDate = new Date(date);

                    if (currentThemeDate.getTime() > existThemeDate.getTime()) {
                        themeTimetableMap.set(theme_id, timetable);
                    }
                    }
                });
      
                const findLastIndex = function (dateStr, themeId) {
                    const compare = (x) => {
                        const { date, theme_id } = x.rates[0];
                        return date === dateStr && theme_id === themeId;
                    };

                    const index = newObj.slice().reverse().findIndex(compare);
                    const count = newObj.length - 1
                    const finalIndex = index >= 0 ? count - index : index;
                    
                    return finalIndex;
                };

                newObj.forEach((item, idx) => {
                    const lastRate = item.rates[0];

                    if (lastRate.timetable?.theme_id !== undefined) {
                    const lastTimetable = themeTimetableMap.get(lastRate.timetable.theme_id);
                    const thematicGrade = theme_gradebooks[lastRate.timetable.theme_id];

                    const lastDateIdx = findLastIndex(lastRate.date, lastRate.timetable.theme_id);

                    if (lastTimetable !== undefined && thematicGrade !== undefined && idx === lastDateIdx) {
                        const timetableDate = new Date(lastTimetable.date);
                        const gradeDate = new Date(lastRate.date);

                        if (timetableDate.getTime() === gradeDate.getTime()) {


                        item.rates = item.rates.concat([
                            {
                            date: lastTimetable.date,
                            rate: thematicGrade[0],
                            isThematic: true,
                            timetable: lastTimetable,
                            isSimple: false,
                            },
                        ]);
                        }
                    }
                    }

                    const existingIndex = courses.findIndex(
                    (v) => v.course_name === item.course_name
                    );

                    if (existingIndex === -1) {
                    courses.push(item);
                    } else {
                    courses[existingIndex].rates = courses[existingIndex].rates.concat(
                        item.rates
                    );
                    }
                });

                courses.forEach((course) => {
                    const courseId = course.course_id;
                    const isCurrentCourse = (item) => item.course === courseId;

                    const firstSemesterRate = firstSemesterGrades.find(isCurrentCourse);
                    const secondSemesterRate = secondSemesterGrades.find(isCurrentCourse);
                    const yearRate = year_grades.find(isCurrentCourse);

                    const setRate = function({ grade = null, semester = null, isYear = false }) {
                    course.rates.push({
                        date: course.date,
                        rate: grade,
                        semester: semester,
                        isSemester: semester !== null,
                        isYear: isYear,
                        isSimple: false,
                    });
                    };

                    setRate({ grade: firstSemesterRate, semester: 1 });
                    setRate({ grade: secondSemesterRate, semester: 2 });
                    setRate({ grade: yearRate, isYear: true });
                });

                courses.forEach((course) => {
                    course.ratesByMonth = {};
                    
                    course.rates.forEach((rate) => {
                        if (!rate.date) {
                            if (!course.ratesByMonth.hasOwnProperty(semesterYearRatesAlias)) {
                                course.ratesByMonth[semesterYearRatesAlias] = [];
                            }

                            course.ratesByMonth[semesterYearRatesAlias].push(rate);

                            return;
                        }

                        const yearMonth = rate.date.slice(0, 7);

                        if (!course.ratesByMonth.hasOwnProperty(yearMonth)) {
                            course.ratesByMonth[yearMonth] = [];
                        }

                        course.ratesByMonth[yearMonth].push(rate);
                    });
                });

                return courses;
            },
            arrayForSearch() {
                return this.studentTimetables.filter(e => e.course_name.toLowerCase().indexOf(this.search_value.toLowerCase()) > -1) || false;
            },
            getCourses() {
                return this.search_value && this.search_value === '' ? this.studentTimetables : this.arrayForSearch;
            },
            students() {
                return this.students_payer && typeof this.students_payer === 'object' ? this.students_payer : false
            },
            shortDate() {
                if (this.studentTimetables && typeof this.studentTimetables === 'object') {
                    let all_dates = [];
                    let newSort = [];
                    for (let item of (this.arrayForSearch || this.studentTimetables)) {
                        for (let rate of item.rates) {
                            all_dates.push(rate.date)
                        }
                    }
                    all_dates.sort((a, b) => new Date(a) - new Date(b));

                    for (let i = 0; i < all_dates.length; i++) {
                        newSort.push(moment(all_dates[i]).format('DD/MM'));
                    }
                    return [...new Set(newSort)];
                }
            },
        },
        methods: {
            studentName(firstName, lastName) {
                return firstName + ' ' + lastName;
            },
            // getLastMonths() {
            //     let last_n_months = [];
            //     let d = new Date();
            //     for(let i = 0; i < 4; i++){
            //         let mm = d.getMonth()+1;
            //         last_n_months[i] = {
            //             name: this.$t('month')[d.getMonth()]+ ' ' + d.getFullYear().toString(),
            //             month: mm < 10 ? '0' + mm : mm.toString(),
            //             year: d.getFullYear().toString()
            //         };
            //         d.setMonth(d.getMonth() - 1)
            //     }
            //     return last_n_months.reverse();
            // },
            // currentMonth() {
            //     let mm = new Date().getMonth()+1;
            //     return {
            //         name: this.$t('month')[new Date().getMonth()]+ ' ' + new Date().getFullYear().toString(),
            //         month: mm < 10 ? '0' + mm : mm.toString(),
            //         year: new Date().getFullYear().toString()
            //     };
            // },
            changeTab(id, index) {
                this.tabActive = index;
                this.isFetch = true;
                this.$store.dispatch('GET_TIMETABLES_LIST', {
                    student_id: id,
                    date_from: this.currentDate.date_from,
                    date_to: this.currentDate.date_to
                })
                .finally(() => {
                    this.isFetch = false;
                });
                this.currentStudentId = id;
                this.$route.params.child_id = id;
                this.pushToUrl(id, 'student');
            },
            getUniqueGrade(arr) {
                const returnArr = (array, date) => {
                    return array
                        .filter(s => s.date.indexOf(date) > -1)
                        .reduce((prev, current) => (prev.priority > current.priority) ? prev : current);
                };
                let results = Array.from(new Set(arr.map(s => s.date)))
                    .map(date => {
                        return {
                            date: date,
                            priority: returnArr(arr, date).priority,
                            rate: returnArr(arr, date).rate || null,
                            themeId: returnArr(arr, date).themeId || null,
                        }
                    })
                    .sort((a, b) => new Date(a.date) - new Date(b.date));

                // console.log('results', results);
                let arrDates = Array.from(this.currentMonthRange(true)
                    .map(item => {
                        return {
                            date: item,
                            priority: 1000,
                            rate: null,
                            inactive: new Date(item) > new Date() ? 1 : 0,
                        }
                    }));

                let map = new Map;

                [arr].forEach(a =>
                    a.forEach(o => map.set(o.date, Object.assign(map.get(o.date) || {}, o)))
                );

                return arr;
            },
            checkRate(item) {
                let rate = null;
                if (item.rate.grade === 0 && item.rate.automatic_grade === 0 ) {
                    rate = ''
                } else if ((item.rate.grade > item.rate.automatic_grade) || (item.rate.grade !== 0) || (item.rate.automatic_grade === 0)) {
                    rate = item.rate.grade
                } else if (item.rate.grade === 0) {
                    rate = item.rate.automatic_grade
                }
                return rate;
            },
            currentMonthRange(fullDates = false) {
                let startDate = new Date(this.currentDate.date_from);
                let endDate = new Date(this.currentDate.date_to);
                let dates = [],
                    currentDate = startDate,
                    addDays = function (days) {
                        let date = new Date(this.valueOf());
                        date.setDate(date.getDate() + days);
                        return date;
                    };
                while (currentDate <= endDate) {
                    if (fullDates) {
                        dates.push(moment(currentDate).format('YYYY-MM-DD'))
                    } else {
                        dates.push(moment(currentDate).format('DD/MM'));
                    }
                    currentDate = addDays.call(currentDate, 1);
                }
                return dates;
            },
            pushToUrl(val, param) {
                let url = new URL(window.location);
                if (url.searchParams.get(param) === null) {
                    url.searchParams.append(param, val)
                } else {
                    url.searchParams.set(param, val)
                }
                if (val === '') {
                    url.searchParams.delete(param)
                }
                window.history.pushState({path: url.href}, '', url.href);
            },
            closeGradeModal() {
                this.modalGradeOpened = false;
                this.modalGradeData = null;
            },
            toggleGradeModal({ e, gradebook, show }) {
                if (
                    gradebook.rate &&
                    (gradebook.rate.isSemester || gradebook.rate.isYear)
                )
                    return;

                if (e.toElement && e.toElement.classList.contains('grade-lesson')) {
                    return;
                }

                if (!show || !gradebook.timetable) {
                    this.modalGradeOpened = false;
                    this.modalGradeData = null;
                    return;
                }

                this.modalGradeData = gradebook;
                this.gradeHoverEvent = e;
                this.modalGradeOpened = true;
            },
            setYearMonthStr(yearMonthStr) {
                if (yearMonthStr === semesterYearRatesAlias) {
                    return '';
                }

                const date = new Date(`${yearMonthStr}-01`);
                
                const dateStr = new Intl.DateTimeFormat('uk', {
                    year: 'numeric',
                    month: 'long',
                }).format(date);
                
                return dateStr;
            },
        },
        created() {
            let searchParams = (new URL(document.location)).searchParams;
            // this.currentDate = this.currentMonth();
            
            let tabIdx = 0;

            if (searchParams.has('student')) {
                this.currentStudentId = searchParams.get('student');
                this.$route.params.child_id = searchParams.get('student');
                tabIdx = this.students_payer.findIndex((e, i) => e.id === +searchParams.get('student'));
            } else {
                this.pushToUrl(this.students[0].id, 'student');
                this.$route.params.child_id = this.students[0].id;
                this.currentStudentId = this.students[0].id;
            }

            if (this.currentStudentId) {
                this.changeTab(this.currentStudentId, tabIdx);
            }
        },
        mounted() {

        },
        watch: {
            currentDate: {
                handler(val) {
                    if (!!val) {
                        this.isFetch = true;
                        this.$store.dispatch('GET_TIMETABLES_LIST', {
                            student_id: this.currentStudentId,
                            date_from: val.date_from,
                            date_to: val.date_to
                        })
                        .finally(() => {
                            this.isFetch = false;
                        });
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped lang="sass">
    @import "../../../sass/variables"
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"
    @import "../../../sass/payer"
    @import "../../../sass/payerCommon"

    .marginLeft
        margin-left: 20px
    .pt-0
        padding-top: 0

    .pb-0
        padding-bottom: 0

    .nothing-found
        margin: 20px 0
        flex: 1
        width: 100%

    .search__input
        background: $white

    .diary-navigation
        display: flex
        align-items: center
        justify-content: space-between

        .chat-head__search
            margin-left: 20px

    .diary-navigation__select
        display: flex
        align-items: center
        margin-left: auto

        .multiselect
            margin-left: 15px
            min-width: 170px
            max-width: 170px

    .diary-table__lc
        max-width: 360px
        padding-top: 15px

    .diary-table__rc
        padding-top: 15px

    .scroll-area
        flex-grow: 1
        background-color: rgb(243, 243, 243)

    .diary-table-loader
        position: relative
        height: 140px

        .fingerprint-spinner
            transform: translate(-50%, -50%)

    .diary-table__courses
        border-right: 1px solid #EEEEEE

        li
            min-height: 63px
            background-color: #fff
            border-bottom: none
        
        li:not(:last-child)
            margin-bottom: 20px

    .diary-table__rc-row-rate
        &:not(:last-child)
            margin-bottom: 20px

    .diary-table__rate
        border-bottom: none

    .diary-table,
    .scroll-area--mb
        background-color: #F3F3F3
        border: none

    .scroll-area--diary
        border: 1px solid $gray
        
    .diary-table__month
        position: relative

        &:hover
            .diary-table__month-name
                opacity: 1

    .diary-table__month-name
        position: absolute
        left: 0
        bottom: 100%
        width: 100%
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
        font-size: 12px
        font-weight: 700
        color: #2B303A
        line-height: 1
        text-align: center
        border-bottom: 3px solid #0E76A8
        opacity: 0.4
        transition: opacity 0.25s ease

    .diary-table__month-rates
        display: flex
</style>
